import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Typography, Row, Col, Avatar, message, Modal } from 'antd';
import { UserOutlined, CheckOutlined, ExclamationCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { apiGetAllUser, apiGiaoJob, apiUpdateStatusUser, apiPushNotiSuper } from '../services/authService';
import { socketManager } from '../utils/socket';

const { TextArea } = Input;
const { Text, Title } = Typography;

const GiaoViecComponent = () => {
    const [jobContent, setJobContent] = useState('');
    const [showEmployeeList, setShowEmployeeList] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [assignedEmployees, setAssignedEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userDepartment, setUserDepartment] = useState('');
    const [currentUserID, setCurrentUserID] = useState('');

    useEffect(() => {
        // Lấy bộ phận và userID từ localStorage
        const job = localStorage.getItem('job');
        const userID = localStorage.getItem('userID');
        if (job) {
            setUserDepartment(job);
        }
        if (userID) {
            setCurrentUserID(userID);
        }

        // Kết nối socket
        socketManager.connect();

        // Cleanup khi component unmount
        return () => {
            socketManager.disconnect();
        };
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            console.log('=== API GET ALL USER ===');
            console.log('User Department:', userDepartment);

            const response = await apiGetAllUser();

            console.log('All Users Response:', response);
            console.log('Response type:', typeof response);

            let usersArray = [];

            // Xử lý response dựa vào cấu trúc API
            if (response && response.data && Array.isArray(response.data)) {
                usersArray = response.data;
            } else if (Array.isArray(response)) {
                usersArray = response;
            }

            console.log('=== PROCESSED USERS ===');
            console.log('Total users:', usersArray.length);
            console.log('Users array:', usersArray);

            // Lọc nhân viên theo part "Máy tính", "Công trình", "Dự án" và "Photocopy"
            const filteredUsers = usersArray.filter(user =>
                user.part === 'Máy tính' || user.part === 'Công trình' || user.part === 'Dự án' || user.part === 'Photocopy' ||
                user.department === 'Máy tính' || user.department === 'Công trình' || user.department === 'Dự án' || user.department === 'Photocopy'
            );

            console.log('=== FILTERED RESULTS ===');
            console.log('User Department:', userDepartment);
            console.log('Users in same department:', filteredUsers.length);
            console.log('Filtered users:', filteredUsers);

            if (filteredUsers.length > 0) {
                console.log('First filtered user:', filteredUsers[0]);
                console.log('User structure keys:', Object.keys(filteredUsers[0]));

                // Log chi tiết từng user
                filteredUsers.forEach((user, index) => {
                    console.log(`User ${index + 1}:`, {
                        id: user.id,
                        username: user.username,
                        part: user.part,
                        department: user.department,
                        avatar: user.avatar,
                        role_id: user.role_id
                    });
                });
            }

            console.log('===============================');

            setEmployees(filteredUsers);

            if (filteredUsers.length === 0) {
                message.warning('Không tìm thấy nhân viên nào trong bộ phận "Máy tính", "Công trình", "Dự án" và "Photocopy"');
            } else {
                // Chỉ hiển thị thông báo success khi lần đầu load hoặc khi user click tải lại
                const availableCount = filteredUsers.filter(emp => emp.status === 0).length;
                message.success(`🔄 Đã cập nhật ${filteredUsers.length} nhân viên • ${availableCount} sẵn sàng nhận việc`);
            }

        } catch (error) {
            console.log('=== API GET ALL USER ERROR ===');
            console.log('Error:', error);
            if (error.response) {
                console.log('Error Response:', error.response.data);
                console.log('Status:', error.response.status);
            }
            console.log('===============================');

            if (error.response) {
                message.error(`Lỗi API: ${error.response.data?.message || 'Không thể lấy danh sách nhân viên'}`);
            } else if (error.request) {
                message.error('Không thể kết nối đến server');
            } else {
                message.error('Đã xảy ra lỗi không mong muốn');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleChooseEmployee = () => {
        if (!jobContent.trim()) {
            message.error('Vui lòng nhập nội dung công việc trước');
            return;
        }

        setShowEmployeeList(true);
        fetchEmployees();
    };

    const handleAssignToEmployee = (employee) => {
        // Kiểm tra xem nhân viên đã được giao việc chưa
        if (assignedEmployees.includes(employee.id)) {
            message.warning(`Đã giao việc cho ${employee.username} rồi`);
            return;
        }

        // Kiểm tra có thể giao việc cho nhân viên hay không
        if (!canAssignToUser(employee)) {
            if (employee.id === 48 && currentUserID !== '48') {
                message.error(`Không thể giao việc cho ${employee.username} vì bạn không có quyền giao việc cho user này!`);
            } else {
                const statusInfo = getUserStatusInfo(employee.status);
                let statusMessage = '';
                switch (employee.status) {
                    case -1:
                        statusMessage = 'có việc chưa nhận';
                        break;
                    case 1:
                        statusMessage = 'đang làm việc';
                        break;
                    default:
                        statusMessage = 'không sẵn sàng';
                }
                message.error(`Không thể giao việc cho ${employee.username} vì nhân viên ${statusMessage}!`);
            }
            return;
        }

        Modal.confirm({
            title: 'Xác nhận giao việc',
            icon: <ExclamationCircleOutlined />,
            content: (
                <div>
                    <p>Bạn chắc chắn muốn giao việc này cho <strong>{employee.username}</strong>?</p>
                    <div style={{ marginTop: '12px', padding: '8px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        <Text strong>Nội dung công việc:</Text>
                        <div style={{ marginTop: '4px', fontSize: '14px', color: '#666' }}>
                            {jobContent}
                        </div>
                    </div>
                    <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#e6f7ff', borderRadius: '4px' }}>
                        <Text strong style={{ color: '#1890ff' }}>Nhân viên:</Text>
                        <div style={{ marginTop: '4px', fontSize: '14px' }}>
                            <Text strong>{employee.username}</Text> (ID: {employee.id})
                        </div>
                    </div>
                </div>
            ),
            okText: 'Xác nhận',
            cancelText: 'Hủy',
            onOk() {
                // Gọi hàm giao việc thực tế
                handleGiaoJob(employee);
            },
            onCancel() {
                console.log('Cancel assign job to', employee.username);
            },
        });
    };

    const handleFinishAssigning = () => {
        if (assignedEmployees.length === 0) {
            Modal.confirm({
                title: 'Chưa giao việc cho ai',
                icon: <ExclamationCircleOutlined />,
                content: 'Bạn chưa giao việc cho nhân viên nào. Bạn có muốn kết thúc không?',
                okText: 'Kết thúc',
                cancelText: 'Tiếp tục',
                onOk() {
                    handleReset();
                }
            });
            return;
        }

        Modal.confirm({
            title: 'Xác nhận kết thúc giao việc',
            icon: <CheckOutlined />,
            content: (
                <div>
                    <p>Bạn đã giao việc xong!</p>
                    <div style={{ marginTop: '12px', padding: '8px', backgroundColor: '#f6ffed', borderRadius: '4px' }}>
                        <Text strong>Tổng kết:</Text>
                        <div style={{ marginTop: '4px', fontSize: '14px' }}>
                            • Đã giao việc cho <strong>{assignedEmployees.length}</strong> nhân viên
                        </div>
                        <div style={{ fontSize: '14px' }}>
                            • Nội dung: {jobContent.substring(0, 50)}{jobContent.length > 50 ? '...' : ''}
                        </div>
                    </div>
                    <p style={{ marginTop: '12px' }}>Bấm "Kết thúc" để xác nhận và về lại giao diện ban đầu.</p>
                </div>
            ),
            okText: 'Kết thúc',
            cancelText: 'Tiếp tục giao việc',
            onOk() {
                message.success(`Hoàn thành giao việc cho ${assignedEmployees.length} nhân viên`);
                handleReset();
            }
        });
    };

    // Hàm cập nhật trạng thái user
    const updateStatusUser = async (id, status) => {
        try {
            const res = await apiUpdateStatusUser(id, status);
            console.log('Updated user status:', res);
        } catch (error) {
            console.error('Error updating user status:', error);
            if (error.response && error.response.status !== 401 && error.response.status !== 403) {
                message.error('Lỗi cập nhật trạng thái user! Vui lòng kiểm tra lại kết nối mạng.');
            }
        }
    };

    // Hàm giao việc thực tế
    const handleGiaoJob = async (employee) => {
        const notificationType = 'new_job';
        const customMessage = 'Bạn có công việc mới, vào xem ngay!';

        try {
            // Giao việc cho nhân viên
            const data = await apiGiaoJob(jobContent, employee.id);
            console.log('Job assigned:', data);

            // Cập nhật trạng thái local của nhân viên về -1 (có việc chưa nhận)
            setEmployees(prevData =>
                prevData.map(item =>
                    item.id === employee.id ? { ...item, status: -1 } : item
                )
            );

            // Bắn socket để app mobile cập nhật
            socketManager.emit('sendJob', { message: 'Toi da giao Job' });

            // Cập nhật trạng thái user về -1
            updateStatusUser(employee.id, -1);

            // Gửi notification nếu có device_token
            if (employee.device_token) {
                const noti = await apiPushNotiSuper(employee.device_token, notificationType, customMessage);
                console.log('Notification sent:', noti);
            }

            // Thêm nhân viên vào danh sách đã giao việc
            setAssignedEmployees([...assignedEmployees, employee.id]);

            message.success(`Đã giao việc cho ${employee.username} thành công!`);
        } catch (error) {
            console.error('Error assigning job:', error);
            if (error.response && error.response.status !== 401 && error.response.status !== 403) {
                message.error('Lỗi! Vui lòng kiểm tra lại kết nối mạng.');
            }
        }
    };

    // Hàm helper để kiểm tra có thể giao việc cho user hay không
    const canAssignToUser = (employee) => {
        // Nếu user có ID = 48 và user đăng nhập không phải ID = 48 thì disable
        if (employee.id === 48 && currentUserID !== '48') {
            return false;
        }

        // Kiểm tra trạng thái user
        const statusInfo = getUserStatusInfo(employee.status);
        return statusInfo.canAssign;
    };

    // Hàm helper để lấy thông tin trạng thái user
    const getUserStatusInfo = (status) => {
        switch (status) {
            case 0:
                return {
                    text: 'Sẵn sàng nhận việc',
                    color: '#52c41a',
                    bgColor: '#f6ffed',
                    borderColor: '#b7eb8f',
                    canAssign: true
                };
            case -1:
                return {
                    text: 'Có việc chưa nhận',
                    color: '#faad14',
                    bgColor: '#fffbe6',
                    borderColor: '#ffe58f',
                    canAssign: false
                };
            case 1:
                return {
                    text: 'Đang làm việc',
                    color: '#ff4d4f',
                    bgColor: '#fff2f0',
                    borderColor: '#ffccc7',
                    canAssign: false
                };
            default:
                return {
                    text: 'Không xác định',
                    color: '#999',
                    bgColor: '#f5f5f5',
                    borderColor: '#d9d9d9',
                    canAssign: false
                };
        }
    };

    const handleReset = () => {
        setJobContent('');
        setShowEmployeeList(false);
        setAssignedEmployees([]);
    };

    return (
        <div style={{ padding: '16px', height: 'calc(100vh - 44px)', overflow: 'hidden' }}>
            <Title level={2} style={{ marginBottom: '10px', fontSize: '18px', marginLeft: 5 }}>Giao việc mới</Title>

            <Row gutter={16} style={{ height: 'calc(100% - 60px)' }}>
                {/* Bên trái - Form nhập công việc */}
                <Col xs={24} lg={showEmployeeList ? 8 : 24}>
                    <Card
                        title="Tạo công việc mới"
                        style={{ height: '100%' }}
                        styles={{ body: { display: 'flex', flexDirection: 'column', height: 'calc(100% - 97px)', padding: '16px' } }}
                    >
                        <div style={{ flex: 1, marginBottom: '30px', display: 'flex', flexDirection: 'column', marginTop: -10 }}>
                            <Text strong style={{ display: 'block', marginBottom: '8px', marginLeft: 5 }}>
                                Nội dung công việc: <span style={{ color: 'red' }}>*</span>
                            </Text>
                            <TextArea
                                value={jobContent}
                                onChange={(e) => setJobContent(e.target.value)}
                                placeholder="Nhập nội dung công việc cần giao..."
                                maxLength={1000}
                                showCount
                                style={{
                                    fontSize: '14px',
                                    resize: 'none',
                                    flex: 1,
                                    minHeight: '200px'
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '12px', flexShrink: 0, marginTop: 5, marginBottom: 150 }}>
                            <Button
                                type="primary"
                                onClick={handleChooseEmployee}
                                disabled={!jobContent.trim()}
                                loading={loading}
                                style={{
                                    flex: 1,
                                    background: !jobContent.trim() ? undefined : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                    border: 'none',
                                    boxShadow: !jobContent.trim() ? undefined : '0 4px 15px 0 rgba(17, 153, 142, 0.4)',
                                    fontWeight: 'bold', fontSize: 14,
                                    transition: 'all 0.3s ease'
                                }}
                                size="large"
                                onMouseEnter={(e) => {
                                    if (!e.target.disabled) {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 20px 0 rgba(17, 153, 142, 0.6)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!e.target.disabled) {
                                        e.target.style.transform = 'translateY(0px)';
                                        e.target.style.boxShadow = '0 4px 15px 0 rgba(17, 153, 142, 0.4)';
                                    }
                                }}
                            >
                                🎯 Chọn nhân viên thực hiện
                            </Button>

                            {showEmployeeList && (
                                <Button
                                    type="primary"
                                    onClick={handleFinishAssigning}
                                    size="large"
                                    style={{
                                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
                                        border: 'none',
                                        boxShadow: '0 4px 15px 0 rgba(255, 107, 107, 0.4)',
                                        fontWeight: 'bold', fontSize: 14,
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 20px 0 rgba(255, 107, 107, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0px)';
                                        e.target.style.boxShadow = '0 4px 15px 0 rgba(255, 107, 107, 0.4)';
                                    }}
                                >
                                    ✅ Kết thúc giao việc ({assignedEmployees.length})
                                </Button>
                            )}
                        </div>
                    </Card>
                </Col>

                {/* Bên phải - Danh sách nhân viên */}
                {showEmployeeList && (
                    <Col xs={24} lg={16}>
                        <Card
                            title={`Danh sách nhân viên (${assignedEmployees.length} đã giao việc)`}
                            style={{ height: '100%' }}
                            styles={{ body: { display: 'flex', flexDirection: 'column', height: 'calc(100% - 57px)' } }}
                        >
                            <div style={{ marginBottom: '12px', padding: '8px', backgroundColor: '#f5f5f5', borderRadius: '6px', marginTop: -10 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                                    <Text strong style={{ fontSize: '15px' }}>
                                        Bộ phận: Máy tính, Công trình, Dự án & Photocopy
                                    </Text>
                                    <Button
                                        type="primary"
                                        size="default"
                                        icon={<ReloadOutlined />}
                                        onClick={fetchEmployees}
                                        loading={loading}
                                        title="Tải lại danh sách nhân viên để cập nhật trạng thái mới nhất"
                                        style={{
                                            fontSize: '12px',
                                            height: '32px',
                                            padding: '0 12px',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            border: 'none',
                                            boxShadow: '0 4px 15px 0 rgba(102, 126, 234, 0.4)',
                                            borderRadius: '6px',
                                            fontWeight: 'bold',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 20px 0 rgba(102, 126, 234, 0.6)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0px)';
                                            e.target.style.boxShadow = '0 4px 15px 0 rgba(102, 126, 234, 0.4)';
                                        }}
                                    >
                                        Tải lại
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Text type="secondary" style={{ fontSize: '13px' }}>
                                        Tổng {employees.length} nhân viên • {assignedEmployees.length} đã giao việc • {employees.filter(emp => emp.status === 0).length} sẵn sàng
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: '10px', fontStyle: 'italic', textAlign: 'right', lineHeight: '1.2', marginTop: '1px' }}>
                                        Bấm nút tải lại để cập nhật lại danh sách nhân viên
                                    </Text>
                                </div>
                                <div style={{ marginTop: '4px', display: 'flex', gap: '8px', fontSize: '12px' }}>
                                    <span style={{ color: '#52c41a' }}>● Sẵn sàng nhận việc</span>
                                    <span style={{ color: '#faad14' }}>● Có việc chưa nhận</span>
                                    <span style={{ color: '#ff4d4f' }}>● Đang làm việc</span>
                                </div>
                            </div>

                            <div style={{ flex: 1, overflow: 'hidden' }}>
                                {/* Chia thành 3 cột theo bộ phận */}
                                <Row gutter={[8, 0]} style={{ height: '100%' }}>
                                    {/* Cột 1: Máy tính & Dự án */}
                                    <Col xs={24} md={8} style={{ height: '100%' }}>
                                        <div style={{
                                            backgroundColor: '#f0f8ff', padding: '6px 8px', borderRadius: '6px', marginBottom: '8px', border: '1px solid #d6e4ff'
                                        }}>
                                            <Text strong style={{ color: '#1890ff', fontSize: '13px' }}>
                                                Máy tính & Dự án ({employees.filter(emp => emp.part === 'Máy tính' || emp.part === 'Dự án' || emp.department === 'Máy tính' || emp.department === 'Dự án').length})
                                            </Text>
                                        </div>
                                        <div style={{ maxHeight: 'calc(100% - 40px)', overflow: 'auto' }}>
                                            {employees
                                                .filter(employee =>
                                                    employee.part === 'Máy tính' || employee.part === 'Dự án' ||
                                                    employee.department === 'Máy tính' || employee.department === 'Dự án'
                                                )
                                                .map((employee) => {
                                                    const isAssigned = assignedEmployees.includes(employee.id);
                                                    const statusInfo = getUserStatusInfo(employee.status);
                                                    const canClick = !isAssigned && canAssignToUser(employee);
                                                    const isRestrictedUser = employee.id === 48 && currentUserID !== '48';

                                                    return (
                                                        <div
                                                            key={employee.id}
                                                            style={{
                                                                padding: '8px',
                                                                border: `2px solid ${isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : statusInfo.borderColor)}`,
                                                                borderRadius: '6px',
                                                                backgroundColor: isAssigned ? '#f6ffed' : (isRestrictedUser ? '#fff2f0' : statusInfo.bgColor),
                                                                cursor: canClick ? 'pointer' : 'not-allowed',
                                                                opacity: canClick ? 1 : 0.6,
                                                                transition: 'all 0.2s', height: '80px', display: 'flex', alignItems: 'center', marginBottom: '6px'
                                                            }}
                                                            onClick={() => canClick && handleAssignToEmployee(employee)}
                                                        >
                                                            <Avatar
                                                                size={32}
                                                                src={employee.avatar}
                                                                icon={<UserOutlined />}
                                                                style={{ marginRight: '8px', flexShrink: 0 }}
                                                            />
                                                            <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px'
                                                                }}>
                                                                    <Text strong style={{
                                                                        fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden',
                                                                        textOverflow: 'ellipsis', lineHeight: '1.2', flex: 1, minWidth: 0
                                                                    }}>
                                                                        {employee.username}
                                                                    </Text>
                                                                    <Text style={{
                                                                        color: '#1890ff',
                                                                        fontSize: '9px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2',
                                                                        backgroundColor: '#e6f7ff',
                                                                        padding: '1px 3px',
                                                                        borderRadius: '3px',
                                                                        border: '1px solid #91d5ff',
                                                                        whiteSpace: 'nowrap',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        {employee.part || employee.department || 'N/A'}
                                                                    </Text>
                                                                    <Text type="secondary" style={{
                                                                        fontSize: '10px',
                                                                        whiteSpace: 'nowrap',
                                                                        lineHeight: '1.2',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        ID: {employee.id}
                                                                    </Text>
                                                                    {isAssigned && (
                                                                        <CheckOutlined
                                                                            style={{
                                                                                color: '#52c41a',
                                                                                fontSize: '12px',
                                                                                flexShrink: 0
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '2px'
                                                                }}>
                                                                    <div style={{
                                                                        width: '6px',
                                                                        height: '6px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: statusInfo.color,
                                                                        marginRight: '4px'
                                                                    }}></div>
                                                                    <Text style={{
                                                                        color: statusInfo.color,
                                                                        fontSize: '10px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {statusInfo.text}
                                                                    </Text>
                                                                </div>
                                                                <Text style={{
                                                                    color: isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : (statusInfo.canAssign ? '#1890ff' : '#999')),
                                                                    fontSize: '10px',
                                                                    fontWeight: isAssigned ? 'bold' : 'normal',
                                                                    display: 'block',
                                                                    lineHeight: '1.2',
                                                                    marginTop: '1px'
                                                                }}>
                                                                    {isAssigned ? '✓ Đã giao việc' : (isRestrictedUser ? '🔒 Không có quyền' : (statusInfo.canAssign ? 'Click để giao việc' : 'Không thể giao việc'))}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </Col>

                                    {/* Cột 2: Công trình */}
                                    <Col xs={24} md={8} style={{ height: '100%' }}>
                                        <div style={{
                                            backgroundColor: '#fff7e6',
                                            padding: '6px 8px',
                                            borderRadius: '6px',
                                            marginBottom: '8px',
                                            border: '1px solid #ffd591'
                                        }}>
                                            <Text strong style={{ color: '#fa8c16', fontSize: '13px' }}>
                                                Công trình ({employees.filter(emp => emp.part === 'Công trình' || emp.department === 'Công trình').length})
                                            </Text>
                                        </div>
                                        <div style={{ maxHeight: 'calc(100% - 40px)', overflow: 'auto' }}>
                                            {employees
                                                .filter(employee =>
                                                    employee.part === 'Công trình' || employee.department === 'Công trình'
                                                )
                                                .map((employee) => {
                                                    const isAssigned = assignedEmployees.includes(employee.id);
                                                    const statusInfo = getUserStatusInfo(employee.status);
                                                    const canClick = !isAssigned && canAssignToUser(employee);
                                                    const isRestrictedUser = employee.id === 48 && currentUserID !== '48';

                                                    return (
                                                        <div
                                                            key={employee.id}
                                                            style={{
                                                                padding: '8px',
                                                                border: `2px solid ${isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : statusInfo.borderColor)}`,
                                                                borderRadius: '6px',
                                                                backgroundColor: isAssigned ? '#f6ffed' : (isRestrictedUser ? '#fff2f0' : statusInfo.bgColor),
                                                                cursor: canClick ? 'pointer' : 'not-allowed',
                                                                opacity: canClick ? 1 : 0.6,
                                                                transition: 'all 0.2s',
                                                                height: '80px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginBottom: '6px'
                                                            }}
                                                            onClick={() => canClick && handleAssignToEmployee(employee)}
                                                        >
                                                            <Avatar
                                                                size={32}
                                                                src={employee.avatar}
                                                                icon={<UserOutlined />}
                                                                style={{ marginRight: '8px', flexShrink: 0 }}
                                                            />
                                                            <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px',
                                                                    marginBottom: '2px'
                                                                }}>
                                                                    <Text strong style={{
                                                                        fontSize: '14px',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        lineHeight: '1.2',
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    }}>
                                                                        {employee.username}
                                                                    </Text>
                                                                    <Text style={{
                                                                        color: '#fa8c16',
                                                                        fontSize: '9px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2',
                                                                        backgroundColor: '#fff7e6',
                                                                        padding: '1px 3px',
                                                                        borderRadius: '3px',
                                                                        border: '1px solid #ffd591',
                                                                        whiteSpace: 'nowrap',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        {employee.part || employee.department || 'N/A'}
                                                                    </Text>
                                                                    <Text type="secondary" style={{
                                                                        fontSize: '10px',
                                                                        whiteSpace: 'nowrap',
                                                                        lineHeight: '1.2',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        ID: {employee.id}
                                                                    </Text>
                                                                    {isAssigned && (
                                                                        <CheckOutlined
                                                                            style={{
                                                                                color: '#52c41a',
                                                                                fontSize: '12px',
                                                                                flexShrink: 0
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '2px'
                                                                }}>
                                                                    <div style={{
                                                                        width: '6px',
                                                                        height: '6px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: statusInfo.color,
                                                                        marginRight: '4px'
                                                                    }}></div>
                                                                    <Text style={{
                                                                        color: statusInfo.color,
                                                                        fontSize: '10px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {statusInfo.text}
                                                                    </Text>
                                                                </div>
                                                                <Text style={{
                                                                    color: isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : (statusInfo.canAssign ? '#1890ff' : '#999')),
                                                                    fontSize: '10px',
                                                                    fontWeight: isAssigned ? 'bold' : 'normal',
                                                                    display: 'block',
                                                                    lineHeight: '1.2',
                                                                    marginTop: '1px'
                                                                }}>
                                                                    {isAssigned ? '✓ Đã giao việc' : (isRestrictedUser ? '🔒 Không có quyền' : (statusInfo.canAssign ? 'Click để giao việc' : 'Không thể giao việc'))}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </Col>

                                    {/* Cột 3: Photocopy */}
                                    <Col xs={24} md={8} style={{ height: '100%' }}>
                                        <div style={{
                                            backgroundColor: '#f9f0ff',
                                            padding: '6px 8px',
                                            borderRadius: '6px',
                                            marginBottom: '8px',
                                            border: '1px solid #d3adf7'
                                        }}>
                                            <Text strong style={{ color: '#722ed1', fontSize: '13px' }}>
                                                Photocopy ({employees.filter(emp => emp.part === 'Photocopy' || emp.department === 'Photocopy').length})
                                            </Text>
                                        </div>
                                        <div style={{ maxHeight: 'calc(100% - 40px)', overflow: 'auto' }}>
                                            {employees
                                                .filter(employee =>
                                                    employee.part === 'Photocopy' || employee.department === 'Photocopy'
                                                )
                                                .map((employee) => {
                                                    const isAssigned = assignedEmployees.includes(employee.id);
                                                    const statusInfo = getUserStatusInfo(employee.status);
                                                    const canClick = !isAssigned && canAssignToUser(employee);
                                                    const isRestrictedUser = employee.id === 48 && currentUserID !== '48';

                                                    return (
                                                        <div
                                                            key={employee.id}
                                                            style={{
                                                                padding: '8px',
                                                                border: `2px solid ${isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : statusInfo.borderColor)}`,
                                                                borderRadius: '6px',
                                                                backgroundColor: isAssigned ? '#f6ffed' : (isRestrictedUser ? '#fff2f0' : statusInfo.bgColor),
                                                                cursor: canClick ? 'pointer' : 'not-allowed',
                                                                opacity: canClick ? 1 : 0.6,
                                                                transition: 'all 0.2s',
                                                                height: '80px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginBottom: '6px'
                                                            }}
                                                            onClick={() => canClick && handleAssignToEmployee(employee)}
                                                        >
                                                            <Avatar
                                                                size={32}
                                                                src={employee.avatar}
                                                                icon={<UserOutlined />}
                                                                style={{ marginRight: '8px', flexShrink: 0 }}
                                                            />
                                                            <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px',
                                                                    marginBottom: '2px'
                                                                }}>
                                                                    <Text strong style={{
                                                                        fontSize: '14px',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        lineHeight: '1.2',
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    }}>
                                                                        {employee.username}
                                                                    </Text>
                                                                    <Text style={{
                                                                        color: '#722ed1',
                                                                        fontSize: '9px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2',
                                                                        backgroundColor: '#f9f0ff',
                                                                        padding: '1px 3px',
                                                                        borderRadius: '3px',
                                                                        border: '1px solid #d3adf7',
                                                                        whiteSpace: 'nowrap',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        {employee.part || employee.department || 'N/A'}
                                                                    </Text>
                                                                    <Text type="secondary" style={{
                                                                        fontSize: '10px',
                                                                        whiteSpace: 'nowrap',
                                                                        lineHeight: '1.2',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        ID: {employee.id}
                                                                    </Text>
                                                                    {isAssigned && (
                                                                        <CheckOutlined
                                                                            style={{
                                                                                color: '#52c41a',
                                                                                fontSize: '12px',
                                                                                flexShrink: 0
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '2px'
                                                                }}>
                                                                    <div style={{
                                                                        width: '6px',
                                                                        height: '6px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: statusInfo.color,
                                                                        marginRight: '4px'
                                                                    }}></div>
                                                                    <Text style={{
                                                                        color: statusInfo.color,
                                                                        fontSize: '10px',
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {statusInfo.text}
                                                                    </Text>
                                                                </div>
                                                                <Text style={{
                                                                    color: isAssigned ? '#52c41a' : (isRestrictedUser ? '#ff4d4f' : (statusInfo.canAssign ? '#1890ff' : '#999')),
                                                                    fontSize: '10px',
                                                                    fontWeight: isAssigned ? 'bold' : 'normal',
                                                                    display: 'block',
                                                                    lineHeight: '1.2',
                                                                    marginTop: '1px'
                                                                }}>
                                                                    {isAssigned ? '✓ Đã giao việc' : (isRestrictedUser ? '🔒 Không có quyền' : (statusInfo.canAssign ? 'Click để giao việc' : 'Không thể giao việc'))}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </Col>
                                </Row>

                                {employees.length === 0 && (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '40px 20px',
                                        color: '#999'
                                    }}>
                                        <Text type="secondary">Không có nhân viên nào trong bộ phận "Máy tính", "Công trình", "Dự án" và "Photocopy"</Text>
                                    </div>
                                )}
                            </div>
                        </Card>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default GiaoViecComponent;
